module.exports = __webpack_public_path__ + "img/uday_logo.822d1e2f.png";